<fgb-banner [title]="'earn.page.banner' | translate"></fgb-banner>

<div class="container mt-4" [ngClass]="isCorporate ? 'corporate-colors' : 'default-color'">
  <fgbcl-earn-points [svgColor]="dropdownColour"></fgbcl-earn-points>
</div>
